import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios'
import { createHashHistory } from 'history';

// Import API config object
import { tokenConfig } from '../utils/apiConfig'

// Import Navbar to be displayed
import NavBar from '../components/NavBar'
import PageNotFound from '../views/PageNotFound';
import LoadingScreen from '../components/LoadingScreen';

function loginPages(LoginComponent, requiredAuth = false, hideNavbar = false) {
    const Authenticate = props => {
        // Auth Constants to manage displays of protected paths
        const [authenticated, setAuthenticated] = useState(false)
        const [invalidToken, setInvalidToken] = useState(false)
        const [userDetails, setUserDetails] = useState(null)
        const [loading, setLoading] = useState(true)
        //Triggering Authentication
        useEffect(() => {
            setLoading(true)
            const auth = async () => {
                await axios.get('/api/auth/user', tokenConfig())
                    .then(res => {
                        setAuthenticated(true)
                        setUserDetails(res.data)
                        setLoading(false)
                    })
                    .catch(err => {
                        localStorage.clear()
                        console.log(err)
                        setInvalidToken(true)
                        setUserDetails(null)
                        setLoading(false)
                    });
            }

            auth()
        }, [authenticated])

        if (props.location.state) {
            if (props.location.state.requireRefresh) {
                const history = createHashHistory();
                const state = { ...history.location.state };
                state.requireRefresh = false
                history.replace({ ...history.location, state });
                window.location.reload()
            }
        }

        if (loading) {
            return <LoadingScreen />
        }

        const currentPath = window.location.pathname

        if (requiredAuth
            && !authenticated
            && currentPath !== '/') {
            return <PageNotFound />
        }

        return (
            <Fragment>
                <NavBar authenticated={authenticated} hideNavbar={hideNavbar} invalidToken={invalidToken} setAuthenticated={setAuthenticated} userDetails={userDetails} />
                <LoginComponent authenticated={authenticated} userDetails={userDetails} setUserDetails={setUserDetails} loading={loading} {...props} />
            </Fragment>
        )
    }
    return Authenticate
}

export default loginPages
